/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
import {useTranslation} from "react-i18next";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {status} from "../../../../../enums/statusEnum";
import {isValidLengthDocumentId} from "../../../../../Apis/functions";
import {InputAdornment, MenuItem} from "@mui/material";
import {Mail} from "@mui/icons-material";
import {CustomPhoneInput} from "../../../../../components/CustomPhoneInput";
import {CustomSelect} from "../../../../../components/CustomSelect";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";
import React from "react";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import {CleanIcon, FolderPerson} from "../../../../../components/buttons/IconButtons";
import {CustomPassword} from '../../../../../components/CustomPassword';
import {DOCUMENT_ID_MIN_LENGTH, PASSWORD_MIN_LENGTH} from "../../../../../constant/variable";

const ManagerFields = ({user, setUser, emptyFields, isValidDocumentId, setIsValidDocumentId, isValidEmail,
                           isValidPhoneNumber, isValidDob, setIsValidDob,
                           handleEmailChange, handlePhoneNumberChange, handleDateChange, handlePasswordChange, statusList, handleClearAll}) => {
    const { t } = useTranslation();

    return (
        <>
            <div className={'row'}>

                {!user?.id &&
                    <div className={"col-12 mb-2 d-flex justify-content-end"}>
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_mf_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={handleClearAll}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                }

                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_mf_name'}
                        length={128}
                        name={'name'}
                        value={user.name}
                        trans={'name'}
                        type={'text'}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                name: e.target.value,
                            }))
                        }
                        required={true}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_mf_last_name'}
                        length={128}
                        name={'last_name'}
                        value={user.lastName}
                        trans={'last_name'}
                        type={'text'}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                lastName: e.target.value,
                            }))
                        }
                        required={true}
                        emptyFields={emptyFields}
                    />
                </div>
                <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                    <CustomTextField
                        id={'txt_mf_second_last_name'}
                        length={128}
                        name={'second_last_name'}
                        value={user.secondLastName}
                        trans={'second_last_name'}
                        type={'text'}
                        onChange={(e) =>
                            setUser((prevData) => ({
                                ...prevData,
                                secondLastName: e.target.value,
                            }))
                        }
                        required={false}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id={'txt_mf_document_id'}
                        length={DOCUMENT_ID_MIN_LENGTH}
                        name={'documentId'}
                        value={user.documentId}
                        trans={'documentId'}
                        type={'text'}
                        onChange={(e) => {
                            let value = e.target.value;
                            setUser((prevData) => ({
                                ...prevData,
                                documentId: value,
                            }));
                            setIsValidDocumentId(isValidLengthDocumentId(value));
                        }}
                        emptyFields={emptyFields}
                        required={true}
                        helperText={'document_id_format'}
                        isValid={isValidDocumentId}
                        isValidText={'document_id_format'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <FolderPerson />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                    <CustomTextField
                        id={'txt_mf_email'}
                        length={128}
                        name={'email'}
                        value={user.email}
                        trans={'email'}
                        type={'text'}
                        onChange={(e) => {
                            setUser((prevData) => ({
                                ...prevData,
                                email: e.target.value,
                            }));
                            handleEmailChange(e.target.value);
                        }}
                        emptyFields={emptyFields}
                        required={true}
                        disabled={!!user.id}
                        isValid={isValidEmail}
                        isValidText={'email_format_invalid'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <Mail />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6'>
                    <CustomPhoneInput
                        id='phit_mf_phone_number'
                        value={user.phoneNumber}
                        onChange={(e) => handlePhoneNumberChange(e, setUser)}
                        emptyFields={emptyFields}
                        required={true}
                        isValid={isValidPhoneNumber}
                    />
                </div>

                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomSelect
                        id={'slt_mf_gender'}
                        name={'gender'}
                        value={user.genderId}
                        keyName={'id'}
                        onChange={(e) => {
                            setUser((prevData) => ({
                                ...prevData,
                                genderId: e.target.value,
                            }));
                        }}
                        list={[
                            { id: 1, name: t('male').toUpperCase() },
                            { id: 2, name: t('female').toUpperCase() },
                        ]}
                        trans={'gender'}
                        label={'lbl_aut_gender'}
                        required={false}
                        showNoSelectionOption={true}
                    />
                </div>

                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomDatePicker
                        id={'dp_mf_dob'}
                        name={'dob'}
                        disabled={false}
                        onChange={(e) => handleDateChange(e, setUser)}
                        trans={'dob'}
                        value={user.dob}
                        required={false}
                        disableFuture={true}
                        openTo={'year'}
                        onError={(error) => setIsValidDob(error === null)}
                        isValid={isValidDob}
                    />
                </div>

                {user?.id && (
                    <div className={'col-sm-12 col-md-6 col-xxl-6 col-lg-6 '}>
                        <CustomSelectAndChildren
                            id={'slt_mf_status_user'}
                            name={'status'}
                            trans={'status'}
                            disabled={true}
                            onChange={(e) => {
                                setUser((prevData) => ({
                                    ...prevData,
                                    statusId: e.target.value,
                                }));
                            }}
                            value={user.statusId}
                        >
                            {statusList?.map((item) => {
                                return <MenuItem value={item?.id}>{t(status[item.id]).toUpperCase()}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </div>
                )}
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomPassword
                        id={'txt_mf_password'}
                        name='password'
                        length={16}
                        minLength={PASSWORD_MIN_LENGTH}
                        value={user?.password}
                        onChange={(e)=>{
                            setUser((prevData) => ({
                                ...prevData,
                                password: e.target.value,
                            }))
                        handlePasswordChange(e.target.value);
                        }}
                        disabled={false}
                        label={'password'}
                        helperText={
                            user?.id
                                ? 'fill_only_if_you_want_to_update_your_password'
                                : 'fill_this_field_only_if_you_want_to_your_password_custom'
                        }
                        autoComplete={'off'}
                    />
                </div>

            </div>
        </>
    );
};

export default ManagerFields;
